import '@mdi/font/css/materialdesignicons.min.css'
import 'font-awesome/css/font-awesome.min.css'
import 'vuetify/styles'
import { createVuetify } from 'vuetify'
import {
  VRow,
  VCol,
  VCard,
  VCardTitle,
  VCardText,
  VCardActions,
  VCardSubtitle,
  VCardItem,
  VIcon,
  VForm,
  VImg,
  VSpacer,
  VSkeletonLoader,
  VDivider,
  VVirtualScroll,
  VSheet,
  VSnackbar,
  VTooltip,
  VPagination,
  VChip
} from 'vuetify/components'
import { ClickOutside, Resize } from 'vuetify/directives'
import { aliases, mdi } from 'vuetify/iconsets/mdi'
import '@/styles/global.scss'

const appTheme = {
  dark: false,
  colors: {
    blue_50: '#EFF6FF',
    blue_100: '#DBEAFE',
    blue_200: '#BFDBFE',
    blue_400: '#1E5EFF',
    blue_500: '#3B82F6',
    blue_600: '#2563EB',
    blue_700: '#1D4ED8',
    blue_900: '#1E3A8A',
    black_10: '#E8E8E8',
    brand: '#005FFF',
    brand_dark: '#0E2841',
    danger_100: '#FEF2F2',
    danger_300: '#FFCCD2',
    danger_700: '#EC2D30',
    danger_800: '#EA0004',
    emerald_50: '#ECFDF5',
    emerald_100: '#D1FAE5',
    emerald_600: '#059669',
    emerald_700: '#047857',
    gray: '#C5C2C0',
    gray_100: '#F3F4F6',
    gray_400: '#9CA3AF',
    gray_900: '#111827',
    off_white: '#F0F4F7',
    orange_100: '#FFEDD5',
    orange_200: '#FED7AA',
    orange_500: '#F97316',
    orange_600: '#EA580C',
    orange_900: '#7C2D12',
    pink_50: '#FDF2F8',
    pink_600: '#DB2777',
    slate_50: '#F8FAFC',
    slate_100: '#F1F5F9',
    slate_200: '#E2E8F0',
    slate_300: '#CBD5E1',
    slate_400: '#94A3B8',
    slate_500: '#64748B',
    slate_600: '#475569',
    slate_700: '#334155',
    slate_800: '#1E293B',
    slate_900: '#0F172A',
    success_700: '#374151',
    white: '#FFFFFF',
    error: '#EC2D30',
    warning_700: '#FE9B0E',
    status_pending: '#FFF1CD',
    status_ready: '#DCE6FF',
    status_in_progress: '#D6F0FF',
    status_cancelled: '#FFE0E0',
    status_completed: '#D5FCE0',
    text_primary: '#F8FAFC',
    text_secondary: '#A3A7AC',
    text_status_pending: '#F09000',
    text_status_ready: '#4F69EB',
    text_status_in_progress: '#0E96FD',
    text_status_cancelled: '#F24646',
    text_status_completed: '#07AB49'
  }
}

export default createVuetify({
  icons: {
    defaultSet: 'mdi',
    aliases,
    sets: {
      mdi
    }
  },
  components: {
    VRow,
    VCol,
    VCard,
    VCardTitle,
    VCardText,
    VCardActions,
    VCardSubtitle,
    VCardItem,
    VIcon,
    VForm,
    VImg,
    VSpacer,
    VSkeletonLoader,
    VDivider,
    VVirtualScroll,
    VSheet,
    VSnackbar,
    VTooltip,
    VPagination
  },
  directives: { ClickOutside, Resize },
  theme: {
    defaultTheme: 'appTheme',
    themes: {
      appTheme
    }
  },
  defaults: {
    VChip: {
      closeIcon: 'mdi-close'
    },
    VDivider: {
      color: 'slate_200'
    }
  }
})
